export const transitions = {
    property: {
        common: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
        colors: 'background-color, border-color, color, fill, stroke',
        dimensions: 'width, height',
        position: 'left, right, top, bottom',
        background: 'background-color, background-image, background-position',
    },
    easing: {
        'ease-in': 'cubic-bezier(0.4, 0, 1, 1)',
        'ease-out': 'cubic-bezier(0, 0, 0.2, 1)',
        'ease-in-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
    },
    duration: {
        fast: '150ms',
        normal: '200ms',
        slow: '300ms',
    },
    delay: {
        fast: '150ms',
        normal: '200ms',
        slow: '300ms',
    },
};
//# sourceMappingURL=transition.js.map